import { faLockAlt as lightLockAlt } from "@jewlr/pro-light-svg-icons/faLockAlt"
import { Box, Typography, Flex } from "@jewlr/storybook/core"
import { Modal } from "@jewlr/storybook/modal"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"

import api from "apis"
import { history } from "app-store-v2/index"
import {
  CheckoutBtn,
  ErrorModalContent,
  Text,
  Title,
} from "areas/order/purchase-warranty/components"
import FontAwesomeIcon from "components/font-awesome-icon"
import { to_currency } from "helpers/number"

const warrantyCheckout = async (selectedOffers, setErrorModal) => {
  try {
    // Strip "No Warranty" from offers
    Object.keys(selectedOffers).forEach((key) => {
      if (selectedOffers[key] === "No warranty") {
        delete selectedOffers[key]
      }
    })
    let body = {
      line_items: selectedOffers,
    }
    let url = "/secure/api/v10/order/purchase_warranty"
    let response = await api.post(url, body)
    if (response.success) {
      history.push(response.data.redirect_url)
    } else {
      // Trigger confirmation modal with error text
      setErrorModal(true)
    }
  } catch (err) {
    setErrorModal(true)
    console.log("ERROR: ", err)
  }
}

const InternalCheckoutBox = ({ selectedOffers, ...props }) => {
  const [subtotal, setSubtotal] = useState(0)
  const [showErrorModal, setErrorModal] = useState(false)

  useEffect(() => {
    // Construct the subtotal by adding price of all selected offers
    // Handle "No warranty" accordingly
    let price = 0
    Object.keys(selectedOffers).forEach((key) => {
      if (selectedOffers[key] !== "No warranty") {
        price += selectedOffers[key].price
      }
    })
    setSubtotal(price)
  }, [selectedOffers])

  return (
    <Flex
      alignItems="center"
      bg="polar"
      borderRadius="13px"
      flexDirection={{ _: "column", tablet: "row" }}
      flexWrap="wrap"
      gutter={2}
      justifyContent="space-between"
      mx={{ _: 2, tablet: 0 }}
      p={{ _: 4, tablet: 5 }}
      {...props}
    >
      <Modal
        height={{ _: "50%", tablet: "100%" }}
        label="Error"
        onClose={() => setErrorModal(false)}
        show={showErrorModal}
        width="50vw"
      >
        <ErrorModalContent />
      </Modal>

      <Box flex="1 1 auto">
        <Text mb={{ _: 2, tablet: 1 }}>
          <Title>Subtotal:</Title>{" "}
          <Typography as="br" display={{ tablet: "none" }} />
          {to_currency(subtotal, { precision: 2 })}
        </Text>
        <Text mb={{ _: 2, tablet: 0 }}>
          <Title>Sale Tax:</Title>{" "}
          <Typography as="br" display={{ tablet: "none" }} />
          Calculated at checkout
        </Text>
      </Box>

      <Box
        flex="3 1 auto"
        textAlign="center"
        width={{ _: "100%", tablet: "auto" }}
      >
        <CheckoutBtn
          disabled={subtotal == 0.0}
          onClick={() => warrantyCheckout(selectedOffers, setErrorModal)}
          startIcon={<FontAwesomeIcon icon={lightLockAlt} />}
        >
          Checkout
        </CheckoutBtn>
      </Box>
    </Flex>
  )
}
InternalCheckoutBox.propTypes = {
  selectedOffers: PropTypes.object,
}
const mapStateToProps = () => {
  return {}
}
const mapDispatchToProps = () => {
  return {}
}
const CheckoutBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalCheckoutBox)
export default CheckoutBox
